/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { memo, useEffect, useState, useMemo } from 'react';
import {
  Button,
  Box,
  Flex,
  Link,
  Stack,
  Table,
  TableHeader,
  TableHeaderRow,
  TableHeaderCell,
  TableBody,
  TableScrollbar,
  Text,
  useColorMode,
  useColorStyle,
  PopoverTrigger,
  Popover,
  PopoverContent,
} from '@tonic-one/react';
import { useToggle } from '@tonic-one/react-hooks';
import customConfig from 'src/config';
import { Trans, useTranslation } from 'react-i18next';

import { useAccountStore } from '../../../models/useAccountModel';
import { useOrgStore } from '../../../models/useOrgModel';
import { useDisclosure } from '@Components/Common/Tooltip/TextEllipsis/utils';

import { AdministrationApi } from '@Apis';

import CSpinner from '../../../components/CSpinner';
import AddButton from './AddButton';
import ApiTokenTable from './ApiTokenTable';
import { ApiTokenData, SelectedRow, ApiData } from './types';
import TitleModal from './TitleModal';
import { AddModal } from './AddModal';
import { EditModal } from './EditModal';
import AddTip from './TipModal/AddTip';
import EditTip from './TipModal/EditTip';
import { PermissionNameEnum } from '@Types/permissions';
import { usePermissionStore } from '@Models/usePermissionModel';
import Organization from '@Components/Common/Organization';
import { CAS_DOC_LINK, getCasOLHLink } from '../../../utils/casDocLink';
import i18next from 'i18next';
function ApiToken() {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation('administration');
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isAddModalOpen, toggleAddModalOpen] = useToggle(false);
  const [isEditModalOpen, toggleEditModalOpen] = useToggle(false);
  const [isAddTipOpen, toggleAddTipOpen] = useToggle(false);
  const [isEditTipOpen, toggleEditTipOpen] = useToggle(false);
  const [saveModalContent, setSaveModalContent] =
    useState<React.ReactNode>(undefined);
  const [saveModal, setSaveModal] = useState<string>('');
  const [editTokenData, setEditTokenData] = useState<ApiData | null>(null);
  const [category, setCategory] = useState<number>(0);
  const [title, setTitle] = useState<string>('');

  const [selectedRow, setSelectedRow] = useState<SelectedRow | null>(null);

  const { groupCompanyGuid } = useAccountStore();
  const { orgsMap, defaultSingleOrgId, switchOrgId, orgId } = useOrgStore();
  const apiTokenOrgId = orgId === 'all' ? groupCompanyGuid : orgId;
  if (defaultSingleOrgId) {
    switchOrgId(defaultSingleOrgId);
  }
  const [loading, setLoading] = useState<boolean>(false);
  const [isRefreshing, setIsRefreshing] = useState<boolean>(false);
  const [accounts, setAccounts] = useState<ApiTokenData[]>([]);
  const [apiDataList, setApiDataList] = useState<any>([]);
  const [addDataList, setAddDataList] = useState<any>();
  const [editDataList, setEditDataList] = useState<any>();
  const fetchData = async () => {
    let data: any = {};
    setLoading(true);
    try {
      data = (await AdministrationApi.apiGetApiAuthenticateToken()).data;
      setApiDataList(data);
    } catch (e) {
      console.error(e);
      // throw new Error('apiGetApiAuthenticateToken error');
      window.showNotification({
        titleMsg: t('common.apiException.internalError'),
        severity: 'error',
      });
    } finally {
      setLoading(false);
      setSelectedRow(null);
    }
    const _accounts: Record<string, ApiTokenData> = {};
    for (const item in data) {
      if (!_accounts[item]) {
        _accounts[item] = {
          orgId: item,
          orgName: orgsMap.get(item) as string,
          apis: [],
        };
      }
      for (const value of data[item]) {
        value.scope = transformApiTokenScope4Frontend(value.scope);
        _accounts[item].apis.push({
          accessToken: value.accessToken,
          category: value.category,
          description: value.description,
          expiredAt: value.expiredAt,
          scope: value.scope,
          tokenType: value.tokenType,
          name: value.name,
        });
      }
    }
    setAccounts(
      Object.values(_accounts).sort((a, b) =>
        a.orgName.toLowerCase() > b.orgName.toLowerCase() ? -1 : 1
      )
    );
  };
  function transformApiTokenScope4Frontend(apiTokenScope: string) {
    const apiTokenScopeFormat = JSON.parse(apiTokenScope);
    const apiTokenScopeRes = {
      sweepingMails: !!apiTokenScopeFormat.v1?.sweeping,
      mitigationMails: !!apiTokenScopeFormat.v1?.mitigation?.mails,
      mitigationAccounts: !!apiTokenScopeFormat.v1?.mitigation?.accounts,
      siemSecurityEvents: !!apiTokenScopeFormat.v1?.siem?.security_events,
      remediationMails: !!apiTokenScopeFormat.v1?.remediation?.mails,
      intelligent: !!apiTokenScopeFormat.v1?.intelligent,
    };
    return apiTokenScopeRes;
  }
  function transformApiTokenScope4Backend(apiTokenScope: any): string {
    const apiTokenScopeFormat: {
      [key: string]: { [key: string]: any };
    } = {};
    apiTokenScopeFormat['v1'] = {};
    if (apiTokenScope.sweepingMails) {
      apiTokenScopeFormat['v1']['sweeping'] = {};
      apiTokenScopeFormat['v1']['sweeping']['mails'] = {};
    }
    if (apiTokenScope.mitigationMails || apiTokenScope.mitigationAccounts) {
      apiTokenScopeFormat['v1']['mitigation'] = {};
      if (apiTokenScope.mitigationMails) {
        apiTokenScopeFormat['v1']['mitigation']['mails'] = {};
      }
      if (apiTokenScope.mitigationAccounts) {
        apiTokenScopeFormat['v1']['mitigation']['accounts'] = {};
      }
    }
    if (apiTokenScope.siemSecurityEvents) {
      apiTokenScopeFormat['v1']['siem'] = {};
      apiTokenScopeFormat['v1']['siem']['security_events'] = {};
    }
    if (apiTokenScope.remediationMails) {
      apiTokenScopeFormat['v1']['remediation'] = {};
      apiTokenScopeFormat['v1']['remediation']['mails'] = {};
    }
    if (apiTokenScope.intelligent) {
      apiTokenScopeFormat['v1']['intelligent'] = {};
    }
    if (apiTokenScope.hunting) {
      apiTokenScopeFormat['v1']['hunting'] = {};
    }
    return JSON.stringify(apiTokenScopeFormat);
  }
  const handleClickMenuItem = (e: any) => {
    if (e.value === null) {
      return;
    }

    setCategory(e.value);
    setTitle(t(`administration.apiToken.table.addToken.title.${e.value}`));
    toggleAddModalOpen();
  };
  const handleAdd = (params: any) => {
    if (params.scope.mitigationAccounts && !params.status) {
      setAddDataList(params);
      toggleAddTipOpen();
    } else {
      confirmAdd(params);
    }
  };
  const confirmAdd = async (params: any) => {
    const _params = JSON.parse(JSON.stringify(params));
    _params.scope = transformApiTokenScope4Backend(_params.scope);
    delete _params.status;
    try {
      const res = await AdministrationApi.apiPostApiAuthenticateToken(_params);
      if (res.data) {
        window.showNotification({
          titleMsg: t('globalSetting.switch.success'),
          severity: 'success',
        });
      } else {
        window.showNotification({
          titleMsg: t('common.apiException.internalError'),
          severity: 'error',
        });
      }
    } catch (error: any) {
      window.showNotification({
        titleMsg: t('common.apiException.internalError'),
        severity: 'error',
      });
    } finally {
      fetchData();
    }
    toggleAddModalOpen();
    toggleAddTipOpen(false);
  };
  const handleClickEdit = (value: ApiData) => {
    console.log(value);
    setEditTokenData(value);
    setTitle(
      t(`administration.apiToken.table.editToken.title.${value.category}`)
    );
    toggleEditModalOpen();
  };
  const handleEdit = (params: any) => {
    const changeScope = transformApiTokenScope4Backend(params.scope);
    const oldScope = transformApiTokenScope4Backend(editTokenData?.scope);
    if (changeScope === oldScope) {
      confirmEdit(params);
    } else {
      setEditDataList(params);
      toggleEditTipOpen();
    }
  };
  const confirmEdit = async (params: any) => {
    const _params = JSON.parse(JSON.stringify(params));
    _params.scope = transformApiTokenScope4Backend(_params.scope);
    if (editTokenData) {
      delete _params.category;
      delete _params.status;
      _params.accessToken = editTokenData.accessToken;
      if (_params.name === editTokenData.name) {
        delete _params.name;
      }
      if (_params.description === editTokenData.description) {
        delete _params.description;
      }
    }
    try {
      const res = await AdministrationApi.apiUpdateAuthenticateToken(_params);
      if (res.data) {
        window.showNotification({
          titleMsg: t('globalSetting.switch.success'),
          severity: 'success',
        });
      } else {
        window.showNotification({
          titleMsg: t('common.apiException.internalError'),
          severity: 'error',
        });
      }
    } catch (error: any) {
      window.showNotification({
        titleMsg: t('common.apiException.internalError'),
        severity: 'error',
      });
    } finally {
      fetchData();
    }
    toggleEditTipOpen();
    toggleEditModalOpen();
  };

  const onDelete = () => {
    setSaveModalContent(t('administration.apiToken.delete.content'));
    setSaveModal('delete');
    onOpen();
  };
  const onRefresh = () => {
    setSaveModalContent(t('administration.apiToken.refresh.content'));
    setSaveModal('refresh');
    onOpen();
  };
  const confirmModal = async () => {
    const param = selectedRow?.accessToken || '';
    setIsRefreshing(true);
    try {
      let res: any;
      if (saveModal === 'delete') {
        res = await AdministrationApi.apiDeleteApiAuthenticateToken(param);
      } else if (saveModal === 'refresh') {
        res = await AdministrationApi.apiRefreshApiAuthenticateToken({
          accessToken: param,
        });
      }
      if (res.data) {
        window.showNotification({
          titleMsg: t('globalSetting.switch.success'),
          severity: 'success',
        });
      } else {
        window.showNotification({
          titleMsg: t('common.apiException.internalError'),
          severity: 'error',
        });
      }
    } catch (error: any) {
      window.showNotification({
        titleMsg: t('common.apiException.internalError'),
        severity: 'error',
      });
    } finally {
      setIsRefreshing(false);
      onClose();
      fetchData();
    }
  };
  const { widthEditablePermission } = usePermissionStore();

  useEffect(() => {
    if (orgId === 'all' || !orgId) {
      switchOrgId(groupCompanyGuid);
    }
    fetchData().catch(() => {
      window.showNotification({
        titleMsg: t('common.apiException.internalError'),
        severity: 'error',
      });
    });
    return () => {
      setAccounts([]);
    };
  }, [apiTokenOrgId]);
  return (
    <>
      {loading && <CSpinner />}
      <Flex
        maxHeight="100%"
        height="100%"
        position="relative"
        direction="column"
        overflow="hide"
      >
        <TitleModal
          visible={isOpen}
          onClose={onClose}
          onConfirm={confirmModal}
          content={saveModalContent}
          isLoading={isRefreshing}
        ></TitleModal>
        {addDataList && (
          <AddTip
            visible={isAddTipOpen}
            onClose={toggleAddTipOpen}
            onConfirm={confirmAdd}
            dataList={addDataList}
          ></AddTip>
        )}
        {editDataList && (
          <EditTip
            visible={isEditTipOpen}
            onClose={toggleEditTipOpen}
            onConfirm={confirmEdit}
            dataList={editDataList}
          ></EditTip>
        )}
        <AddModal
          visible={isAddModalOpen}
          onClose={toggleAddModalOpen}
          onSave={handleAdd}
          orgId={orgId}
          category={category}
          title={title}
        />
        <EditModal
          visible={isEditModalOpen}
          onClose={toggleEditModalOpen}
          onSave={handleEdit}
          orgId={orgId}
          editTokenData={editTokenData}
          title={title}
        />
        <Box flexShrink="0" pl="16px">
          <Text fontWeight="400" fontSize="18px" lineHeight="24px" py="16px">
            {t('administration.apiToken.title')}
          </Text>
          <Text>{t('administration.apiToken.content')}</Text>
          <Text>
            <Trans
              i18nKey={`administration.apiToken.link`}
              values={{
                URL: customConfig.ui.administrator.apiTokenUrl,
              }}
            >
              placeholder
              <span>placeholder</span>
              placeholder
            </Trans>
          </Text>
          <Flex m="16px 0">
            <Box
              as="span"
              position="static"
              fontSize="14px"
              lineHeight="25px"
              mr="16px"
              color={colorStyle.color.secondary}
            >
              {t('common.label.currentOrganization')}:
            </Box>
            <Organization showLabel={false} allOrgItem={false} />
          </Flex>
          <Flex justifyContent="space-between" pr="8px">
            {selectedRow !== null ? (
              <Box mr={16}>
                <Button
                  variant="secondary"
                  mr={16}
                  onClick={onDelete}
                  disabled={
                    !widthEditablePermission(
                      PermissionNameEnum.administrator
                    ) || isRefreshing
                  }
                >
                  {t('common.action.label.delete')}
                </Button>
                <Button
                  variant="primary"
                  onClick={onRefresh}
                  disabled={
                    !widthEditablePermission(
                      PermissionNameEnum.administrator
                    ) || isRefreshing
                  }
                >
                  {t('recommendConfig.filter.checkConfig')}
                  {/* Refresh */}
                </Button>
              </Box>
            ) : null}
            {selectedRow === null ? (
              <AddButton
                orgId={apiTokenOrgId}
                apiDataList={
                  apiDataList ? apiDataList[apiTokenOrgId] : apiDataList
                }
                handleClickMenuItem={handleClickMenuItem}
              />
            ) : null}
            <OLH />
          </Flex>
        </Box>

        <Box flexGrow="1" overflow="hide">
          <Table width="100%" height="100%" size="lg">
            <ApiTokenHeader />
            <TableScrollbar height="100%" overflow="visible">
              <TableBody width="100%">
                {accounts.map((account) => (
                  <ApiTokenTable
                    key={account.orgId}
                    orgName={account.orgName}
                    selectOrgId={orgId}
                    account={account}
                    selectedRow={selectedRow}
                    setSelectedRow={setSelectedRow}
                    handleClickEdit={handleClickEdit}
                  />
                ))}
              </TableBody>
            </TableScrollbar>
          </Table>
        </Box>
      </Flex>
    </>
  );
}

const ApiTokenHeader = memo(() => {
  const { t } = useTranslation('administration');
  return (
    <TableHeader width="100%">
      <TableHeaderRow width="100%">
        <TableHeaderCell width="32px" />
        <TableHeaderCell width="35%" flexGrow="2">
          {t('administration.apiToken.table.header.token')}
        </TableHeaderCell>
        <TableHeaderCell width="15%" flexGrow="1">
          {t('administration.apiToken.table.header.service')}
        </TableHeaderCell>
        <TableHeaderCell width="20%" flexGrow="1">
          {t('administration.apiToken.table.header.apiType')}
        </TableHeaderCell>
        <TableHeaderCell width="150px" flexGrow="1">
          {t('administration.apiToken.table.header.expirationDate')}
        </TableHeaderCell>
        <TableHeaderCell width="50px" flexGrow="1">
          {t('administration.apiToken.table.header.status')}
        </TableHeaderCell>
      </TableHeaderRow>
    </TableHeader>
  );
});

export default ApiToken;

const OLH = () => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation();
  return (
    <Popover placement="bottom-end" trigger="hover">
      <PopoverTrigger>
        <Flex gap="4px" alignSelf="flex-start" cursor="pointer">
          <Text
            color={colorStyle.color.tertiary}
            borderBottom="1px solid"
            _hover={{ color: '#6F9BF4' }}
          >
            {t('administration.apiToken.olh.title')}
          </Text>
        </Flex>
      </PopoverTrigger>
      <PopoverContent maxWidth="auto">
        <Stack px="8px">
          {(
            [
              'getStart',
              'logRetrieval',
              'threatInvestigation',
              'threatMitigation',
              'threatRemediation',
            ] as const
          ).map((v) => (
            <Link
              key={v}
              href={getCasOLHLink(
                CAS_DOC_LINK.administrator.apiTokens[v],
                i18next.language
              )}
              target="_blank"
            >
              <li>{t('administration.apiToken.olh.' + v)}</li>
            </Link>
          ))}
        </Stack>
      </PopoverContent>
    </Popover>
  );
};
